import styled from 'styled-components';

const NoSearchResultsTitleValue = styled.span`
  font-weight: bold;
`;

export default NoSearchResultsTitleValue;



// WEBPACK FOOTER //
// ./components/SearchResultsPanel/NoSearchResultsTitleValue.js